import { createSlice } from '@reduxjs/toolkit';
import { removeStorageItem, setStorageItem } from '../../helpers/storage';
import type { GetViewExtended } from '../config/views';
import type { RootState } from '../store';
import type { GlobalFilterQuickDateRange } from './globalFilter/global-dates-filter-slice';

export interface ViewWithRange extends GetViewExtended {
  quickDateRange?: GlobalFilterQuickDateRange;
}
const initialState: { selectedView?: ViewWithRange } = {
  selectedView: undefined,
};

const selectedViewSlice = createSlice({
  name: 'selectedView',
  initialState: initialState,
  reducers: {
    setSelectedView(state, action) {
      state.selectedView = action.payload;
      setStorageItem('lastUsedView', action.payload, 'sessionStorage');
    },
    clearSelectedView(state) {
      state.selectedView = undefined;
      removeStorageItem('lastUsedView', 'sessionStorage');
    },
  },
});

export default selectedViewSlice.reducer;
export const { setSelectedView, clearSelectedView } = {
  ...selectedViewSlice.actions,
};
export const selectCurrentView = (state: RootState) => state.rootReducer.selectedView;
